module.exports = __webpack_public_path__ + "images/mopar_small9dc5a3d89673232af71c4d5ae8053751.png";